import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/joomla': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0.6 92.1c0-33.3 26.8-60.1 59.8-60.1 30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1 0.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9-26.9-5.8-46.7-29.7-46.7-58.3zM130.1 208.5c28.5-28.4 81.3-80.8 99.6-99.9 26.6-26.6 64.5-35 98.3-25.1 4.1-29.1 29.2-51.6 59.5-51.6 33 0 59.8 26.9 59.8 60.1 0 30.3-22.7 55.4-51.9 59.5 9.6 33.6 2.3 70-28.9 101.2l-44-44.3c20.5-20.4 16.3-42.6 3.5-55.4-14.3-14.3-37.6-14.3-51.9 0-10 10.1-89.7 89.8-99.7 99.8zM396.4 360.7c29.1 4.1 51.6 28.9 51.6 59.1 0 33.3-26.8 60.1-59.8 60.1-29.2 0-53.4-20.7-58.9-48.1-34.7 10.8-75.1 2.2-102.7-28l44-44.3c20.4 20.5 42.6 16.3 55.4 3.5 14.3-14.3 14.3-37.6 0-51.9l-99.7-99.7 44.3-44.3c104.5 104.4 87.7 87.5 99.5 99.7 25.4 25.4 34.5 61.2 26.3 93.9zM312.1 307.6c-87.3 87.3-67.4 67.7-99.5 99.7-25.7 25.4-61.5 34.2-94.2 26-6.1 26.9-30 46.7-58.6 46.7-33 0-59.8-26.8-59.8-60.1 0-28.3 19.5-52.2 46.2-58.2-8.5-33.1-0.7-68.1 29.5-98.3l44 44.3c-20.1 20.1-16.3 42-3.2 55.4 14.3 14.3 37.6 14.3 51.9 0 49.3-49.4 12.7-13.4 99.7-99.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/joomla.js
// module id = 902
// module chunks = 0